<template>
    <div class='container'>
        <div class="check_order">

            <div class="title">
                <i class="icon-new_order mr-5"></i>
                <span>訂單查詢</span>
            </div>
            <div class="check">
                <div class="check_flex">
                    <input @keyup.enter="keyDown($event)" type="text" v-model="value" placeholder="請輸入訂單號">
                    <div class="search" @click="keyDown($event)">查詢</div>
                </div>
            </div>
        </div>
        <div class="check_order">

            <div class="title">
                <i class="icon-new_order mr-5"></i>
                <span>手機號查詢訂單號</span>
            </div>
            <div class="check">
                <div class="check_flex">
                    <input @keyup.enter="keyDownPhone($event)" type="text" v-model="phone_number" placeholder="請輸入手機號">
                    <div class="search" @click="keyDownPhone($event)">查詢</div>
                </div>
                <div v-if="see_order_number">
                    <ul style="list-style-type: none; padding: 10px 0px 0px; font-size: 20px;" v-if="this.judgment">
                        查詢到的訂單號:
                        <li v-for="item, index in  order_number">{{ index + 1 }}. {{ item }}</li>
                    </ul>
                    <ul style="list-style-type: none; text-align: center; padding: 10px 0px 0px; font-size: 20px;" v-else>
                        該手機號暫無訂單
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import $ from 'jquery'
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            value: '',
            phone_number: '',
            order_number: [],
            judgment: false,
            see_order_number: false,
            webmeta: {
                og_title: '',
                check_title: '',
                check_description: ''
            }
        };
    },
    computed: {
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
        computedOgTitle() {
            return this.seo.og_title || '';
        },
        computedTitle() {
            return this.seo.check_title || '';
        },
        computedDescription() {
            return this.seo.check_description || '';
        }
    },
    metaInfo() {
        return {
            title: this.webmeta.check_title || this.webmeta.og_title,
            meta: [
                { vmid: 'description', name: 'description', content: this.webmeta.check_description },
            ]
        }
    },
    watch: {},
    methods: {
        keyDown(e) {
            if (this.value === null || this.value === undefined || this.value === ''){
                return
            }else{
                let value = this.value
                this.$router.push({
                    path: `/order/${value}`
                }).catch(err => { })
            }
        },
        keyDownPhone(e) {
            if (this.phone_number === null || this.phone_number === undefined || this.phone_number === ''){
                return
            }else{

                this.order_number = [];
                this.$store.dispatch('order/payment_two', { data: this.phone_number, phone: 'phone' }).then((e_state) => {
                    // console.log(this.$store.getters['order/order']);
    
                    if (e_state == false) {
                        this.judgment = false
                    } else {
                        this.judgment = true;
                        this.$store.getters['order/order'].forEach((e) => {
                            this.order_number.push(e.order.order_num);
                        });
                    }
    
                    if (this.$store.getters['order/order'].length == 0) {
                        this.judgment = false;
                    }
                    this.see_order_number = true;
    
                    // console.log(this.order_number);
                });
            }

        }
    },
    created() {
        this.webmeta.og_title = this.computedOgTitle;
        this.webmeta.check_title = this.computedTitle;
        this.webmeta.check_description = this.computedDescription;
    },
    mounted() {
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>